import { render, staticRenderFns } from "./SectionSpecsV1.vue?vue&type=template&id=b16a495a&"
import script from "./SectionSpecsV1.vue?vue&type=script&lang=js&"
export * from "./SectionSpecsV1.vue?vue&type=script&lang=js&"
import style0 from "./SectionSpecsV1.vue?vue&type=style&index=0&id=b16a495a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomToggle: require('/app/components/atoms/common/AtomToggle.vue').default,OrganismsProjectOrganismTabsTechnicalSpecs: require('/app/components/organisms/project/OrganismTabsTechnicalSpecs.vue').default})
